import type { GroupResponse } from 'tm3-core/api.dtos';

import EVariant from './enums/variant';
import type { IEvent } from './ievent';

interface IGroupUpdateEvent extends IEvent {
  group?: GroupResponse;
  variant: EVariant;
}

class GroupUpdateEvent implements IGroupUpdateEvent {
  private static init: Partial<IGroupUpdateEvent> = {
    variant: EVariant.created
  };

  group?: GroupResponse;
  variant!: EVariant;

  public constructor(init: Partial<IGroupUpdateEvent> = {}) {
    Object.assign(this, GroupUpdateEvent.init as IGroupUpdateEvent, init as IGroupUpdateEvent);
  }
}

export default GroupUpdateEvent;
